// extracted by mini-css-extract-plugin
module.exports = {"FilterWrapper":"filters_FilterWrapper__1Ts9Z","FilterWrapperOpen":"filters_FilterWrapperOpen__2dnqT","FilterWrapperClosed":"filters_FilterWrapperClosed__3B0cw"};